import { render, staticRenderFns } from "./DPostContentPreview.vue?vue&type=template&id=33fc3e5d&scoped=true&"
import script from "./DPostContentPreview.vue?vue&type=script&lang=js&"
export * from "./DPostContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./DPostContentPreview.vue?vue&type=style&index=0&id=33fc3e5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc3e5d",
  null
  
)

export default component.exports